import { vMaska } from 'maska/vue'

import { defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin(nuxtApp => {
  // console.log('[NUXT] 23.maska.client.js')
  nuxtApp.vueApp.directive('maska', vMaska)
})
